import { breakpoints } from '@99designs/common/core/settings';
import { DesignerCard_User } from '__generated__/DesignerCard_User';
import React from 'react';
import MediaQuery from 'react-responsive';
import CompactMeta from './BriefLayouts/CompactMeta';
import TabularMeta from './BriefLayouts/TabularMeta';
import Card from './Card';
import DesignCarousel from './DesignCarousel';
import DesignerMetaContext, { DesignerMetaLayouts } from './DesignerMetaContext';

export interface Props {
    user: DesignerCard_User;
    isSelected: boolean;
    onMount: () => void;
}

class DesignerCard extends React.Component<Props> {
    getMeta = (layout: DesignerMetaLayouts) => {
        const user = this.props.user;

        switch (layout) {
            case DesignerMetaLayouts.tabular:
                return <TabularMeta designer={user} />;
            default:
                return <CompactMeta designer={user} />;
        }
    };

    componentDidMount() {
        this.props.onMount();
    }

    render() {
        const { user, isSelected, children } = this.props;

        return (
            <Card variations={isSelected ? ['selected'] : []}>
                <Card.Block>
                    <DesignerMetaContext.Consumer>
                        {({ layout }) => this.getMeta(layout)}
                    </DesignerMetaContext.Consumer>
                </Card.Block>
                <Card.Media>
                    <MediaQuery minWidth={breakpoints.normal[0]}>
                        {matches => <DesignCarousel designer={user} enableOverlay={matches} />}
                    </MediaQuery>
                </Card.Media>
                <Card.Block>{children}</Card.Block>
            </Card>
        );
    }
}
export default DesignerCard;
